import Dynamic from 'next/dynamic';
import PropTypes from 'prop-types';

const BreadcrumbGeneratorComponent = Dynamic(
  () => import('components/BreadcrumbGeneratorComponent'),
  { ssr: true }
);

const createSchoolPaths = (country, city) => {
  const result = [];

  result.push({
    text: 'Intercâmbio',
    type: 'link',
    href: '/intercambio',
  });

  result.push({
    text: 'Escolas',
    type: country ? 'link' : 'text',
    href: country ? '/schools' : '',
  });

  if (country) {
    result.push({
      text: country?.name,
      type: city ? 'link' : 'text',
      href: city ? `/schools/${country?.slugName}` : '',
    });
  }

  if (city) {
    result.push({
      text: city?.name,
      type: 'text',
    });
  }

  return result;
};

function SchoolsBreadcrumbComponent({ country, city }) {
  const paths = createSchoolPaths(country, city);

  return <BreadcrumbGeneratorComponent paths={paths} />;
}

SchoolsBreadcrumbComponent.propTypes = {
  country: PropTypes.instanceOf(Object),
  city: PropTypes.instanceOf(Object),
};

SchoolsBreadcrumbComponent.defaultProps = {
  country: null,
  city: null,
};

export default SchoolsBreadcrumbComponent;
